import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './ui/accordion';
import { faqs } from '../data/mock';

const FaqSection = () => (
  <section id="faq" className="py-24 bg-[#0a0a0a]" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-6">
      <div className="text-center mb-14">
        <span className="text-[#FF6B00] font-bold text-sm uppercase tracking-wider">Dúvidas</span>
        <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
          Perguntas <span className="text-[#FF6B00]">Frequentes</span>
        </h2>
      </div>
      <Accordion type="single" collapsible className="space-y-4">
        {faqs.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`faq-${i}`}
            className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg px-6 data-[state=open]:border-[#FF6B00] transition-colors"
          >
            <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="text-white text-base md:text-lg font-semibold hover:no-underline hover:text-[#FF6B00] py-5 [&>svg]:text-[#FF6B00] [&>svg]:h-5 [&>svg]:w-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-content-${i + 1}`} className="text-gray-400 text-base leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FaqSection;
